


<template>
  <div>
    <iframe
      allowfullscreen="allowfullscreen"
      scrolling="no"
      class="fp-iframe"
      src="https://heyzine.com/flip-book/de580e1f39.html"
      style="border: 1px solid lightgray; width: 100vw; height: 100vh"
    />
  </div>
</template>

<script setup>
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>






<!-- 
  <template>
  <h1>To Do</h1>
  <h2>PBTPay</h2>
  <PrimaryModule />
  <PengurusanMaklumat />
  </template>

  <script setup>
  definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
  layout: 'blank',
  public: true,
  },
  })
  </script>   
-->





